import React from 'react';
import './App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
  faExpandArrowsAlt, 
  faCompressArrowsAlt, 
  faInfo,
  faStepForward,
  faStepBackward,
  faPlay,
  faPause,
} from '@fortawesome/free-solid-svg-icons'

const apiBase = 'https://collectionapi.metmuseum.org/public/collection/v1'

const galleryNameRe = /^Gallery *(\d\d?\d?)$/;
function handleIframeConsoleLog(arg){
  if(arg && arg.name){
    const m = arg.name.match(galleryNameRe);
    if(m){
      this.setState({selectedGallery: parseInt(m[1])})
    }
  }
  this.oldConsoleLog.apply(this.iframeContentWindow.console, arguments);
}

const PAGES = {
  GALLERY_VIEWER : 'galleryViewer',
  GALLERY_MAP_SELECTOR : 'galleryMapSelector',
}

class App extends React.Component {

  constructor(){
    super()
    this.state = {
      departments:[],
      selectedDepartment:undefined,
      initialResponse:null,
      loadingImageIndex:null,
      loadingImageResponse:null,
      loadedImageResponse:null,
      isShowingControls:true,
      isPlaying:false,
      isShowingInfo:false,
      slideshowDelay: 10,
      isFullscreen: false,
      page: PAGES.GALLERY_MAP_SELECTOR,
      selectedGallery: null,
    };
  }

  componentDidMount(){
    document.domain = document.domain;    //facilitate communication with map iframe: https://stackoverflow.com/a/55425476
    document.addEventListener("fullscreenchange", () => {
      this.setState({isFullscreen: !!document.fullscreenElement})
    });
  }

  loadGallery = () => {
    clearTimeout(this.imageTimeout);
    const queryUrl2 = `https://www.metmuseum.org/mothra/collectionlisting/search?artist=&department=&era=&geolocation=&material=&offset=0&pageSize=0&perPage=80&q=${this.state.selectedGallery}&searchField=Gallery&showOnly=&sortBy=Relevance&sortOrder=asc`;
    fetch(queryUrl2)
      .then(res => {
        return res.json()
      }).then(o => {
        this.setState({
          loadingImageResponse:null,
          initialResponse: o, 
          loadingImageIndex: 0
        }, () => this.loadNextImage(true))
      })
  }

  objectIdRe = /^https:\/\/www.metmuseum.org\/art\/collection\/search\/(\d+)?.*$/
  
  loadNextImage = (explicitUserAction) => {
    //fetch first two jsons
    //load one image, wait for it to load
    //show it on load
    //start loading second image
    //show it on load while loading next image
    const objectIdMatch = this.state.initialResponse.results[this.state.loadingImageIndex].url.match(this.objectIdRe) 
    const objectId = objectIdMatch[1];

    fetch(`${apiBase}/objects/${objectId}`)
      .then(res => res.json())
      .then(response => {
        //debugger
        if(response.primaryImage){
          const newState = {
            loadedImageResponse: explicitUserAction ? response : this.state.loadingImageResponse,
            loadingImageResponse: response,
          };
          this.setState(newState)
        } else {
          this.setState({loadingImageIndex : this.getNextImageIndex()}, this.loadNextImage)
        }
      }) 
  }

  getNextImageIndex() {
    return (this.state.loadingImageIndex + 1) % this.state.initialResponse.results.length;
  }

  handleImgLoad = () => {
    if(this.state.isPlaying){
      this.setState(
        { loadingImageIndex : this.getNextImageIndex()}, 
        () => {
            this.imageTimeout = setTimeout(this.loadNextImage, this.state.loadingImageIndex > 1 ? this.state.slideshowDelay * 1000 : 0)
        }
      )
    }
  }

  handleClickOnImages = () => {
      this.setState({isShowingControls:!this.state.isShowingControls})
  }

  handleClickOnToggleFullscreen = () => {
    if (!document.fullscreenElement && document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen(); 
      }
    }
  }

  handleClickOnTogglePlayPause = () => {
    clearTimeout(this.imageTimeout);
    this.setState({isPlaying:!this.state.isPlaying}, this.handleImgLoad)
  }
getNextImageIndex
  handleClickOnForward = () => {
    this.setState({
      isPlaying:false, 
      loadingImageIndex : this.getNextImageIndex()
    }, this.loadNextImage.bind(this,true))
  }

  handleClickOnBack = () => {
    this.setState({
      isPlaying:false, 
      loadingImageIndex : this.state.loadingImageIndex - 1 % this.state.initialResponse.results.length
    }, this.loadNextImage.bind(this,true))
  }

  handleClickOnToggleInfo = () => {
    this.setState({isShowingInfo : !this.state.isShowingInfo})
  }

  handleSlideshowDelayRangeChange = (evt) => {
    this.setState({slideshowDelay: parseInt(evt.target.value)})
  }

  handleIframeLoad = (evt) => {
    //debugger
    this.iframeContentWindow = evt.target.contentWindow;
    if(this.iframeContentWindow){
      this.oldConsoleLog = this.iframeContentWindow.console.log;
      this.iframeContentWindow.console.log = handleIframeConsoleLog.bind(this); 
    }
  }

  goFromGalleryMapToViewer = () => {
    this.setState({
      page : PAGES.GALLERY_VIEWER,
      isPlaying:true,
    }, this.loadGallery)
  }

  goFromViewerToMap = () => {
    clearTimeout(this.imageTimeout);
    this.setState({
      page : PAGES.GALLERY_MAP_SELECTOR,
      initialResponse:null,
      loadingImageIndex:null,
      loadingImageResponse:null,
      loadedImageResponse:null,
      isPlaying:false,
    })
  }

  render(){
    //debugger
    const displayControls = this.state.isShowingControls ? {} : {display: 'none'};
    const url = 'http://maps.museumexplorer.io';    //TODO: make this a build parameter
    //const url = 'http://maps.museumexplorer.io:3001/';
    //const url = 'http://maps.metmuseum.org';

    return <div className="main">
      <div className="galleryMapSelector page"  style={{display: this.state.page === PAGES.GALLERY_MAP_SELECTOR ? 'flex' : 'none'}}>
        <div className="upperControls">
          <div style={{'float':'left'}}> Choose a gallery to explore </div>
          <button 
            style={{'float':'right'}} 
            disabled={!this.state.selectedGallery}
            onClick={this.goFromGalleryMapToViewer}> Go to gallery {this.state.selectedGallery} &rarr; </button>
        </div>
        <iframe 
          frameBorder="0"
          className="grow" 
          title="galleryMap"
          onLoad={this.handleIframeLoad}
          src={url} />
      </div>
      <div className="galleryViewer page" style={{display: this.state.page === PAGES.GALLERY_VIEWER ? 'flex' : 'none'}}>
        <div className="upperControls" style={displayControls}>
          <button onClick={this.goFromViewerToMap} style={{'float':'left'}}> &larr; Choose a different Gallery </button>
          <div style={{'float':'right'}}> Exploring gallery {this.state.selectedGallery} </div>
        </div>
        <div className="grow" onClick={this.handleClickOnImages}>
          <div className="imageContainer">
            {
              this.state && this.state.loadingImageResponse &&
                <img 
                  onLoad={this.handleImgLoad}
                  src={this.state.loadingImageResponse.primaryImage} 
                  alt={this.state.loadingImageResponse.title} 
                  style={{display:"none"}} />
            }
            {
              this.state && this.state.loadedImageResponse &&
                <img 
                  src={this.state.loadedImageResponse.primaryImage} 
                  alt={this.state.loadedImageResponse.title} 
                  key={this.state.loadedImageResponse.objectID} 
                  style={{display:"block"}} />
            }
          </div>
          {
            this.state && this.state.isShowingInfo && this.state.loadedImageResponse &&
              <div className="info">
                <div>{this.state.loadedImageResponse.title}</div>
                <div>{this.state.loadedImageResponse.objectDate}</div>
                <div>{this.state.loadedImageResponse.artistDisplayName}</div>
                <div>{this.state.loadedImageResponse.artistDisplayBio}</div>
              </div>
          }
        </div>
        <div className="lowerControls" style={displayControls}>
          <select
            value={this.state.slideshowDelay}
            onChange={this.handleSlideshowDelayRangeChange}>
            {
              (() => {
                const x = [];
                for(let i = 1; i <= 60; i++){
                  x.push(<option key={i} value={i}>{i} second delay</option>);
                }
                return x;
              })()
            }
          </select>
          <button onClick={this.handleClickOnBack}><FontAwesomeIcon icon={faStepBackward} /></button>
          <button onClick={this.handleClickOnTogglePlayPause}>
            {
              this.state.isPlaying?
                <span><FontAwesomeIcon icon={faPause} /></span>:
                <span><FontAwesomeIcon icon={faPlay} /></span>
            }
          </button>
          <button onClick={this.handleClickOnForward}><FontAwesomeIcon icon={faStepForward} /></button>
          <button onClick={this.handleClickOnToggleInfo}><FontAwesomeIcon icon={faInfo} /></button>
          <button onClick={this.handleClickOnToggleFullscreen}>
            {
              this.state.isFullscreen ?
                <FontAwesomeIcon icon={faCompressArrowsAlt} /> :
                <FontAwesomeIcon icon={faExpandArrowsAlt} />
            }
          </button>
        </div>
      </div>
    </div>
  }
}

export default App;
